import axios from 'axios'
import Api from '../Api'
import {
    ASSET_TYPES_FETCHING,
    ASSET_TYPES_FETCHING_FAILURE,
    ASSET_TYPES_FETCHING_SUCCESS,
    CLEAR_FILE_DATA_FORM,
    FILE_DATA_FORM_ADD_MODEL,
    FILE_DATA_FORM_ADD_MODEL_EDIT,
    FILE_DATA_FORM_ADD_SKU,
    FILE_DATA_FORM_ADD_SKU_EDIT,
    FILE_DATA_FORM_DELETE,
    FILE_DATA_FORM_REMOVE_MODEL,
    FILE_DATA_FORM_REMOVE_MODEL_EDIT,
    FILE_DATA_FORM_REMOVE_SKU,
    FILE_DATA_FORM_REMOVE_SKU_EDIT,
    FILE_DATA_FORM_TOGGLE_ACTIVE,
    PRODUCT_ASSETS_FETCHING,
    PRODUCT_ASSETS_FETCHING_FAILURE,
    PRODUCT_ASSETS_FETCHING_SUCCESS,
    SAVING_FILE_DATA,
    SAVING_FILE_DATA_FAILURE,
    SAVING_FILE_DATA_SUCCESS,
    UPDATE_FILE_DATA,
    UPDATE_FILE_DATA_FAILURE,
    UPDATE_FILE_DATA_FORM,
    UPDATE_FILE_DATA_FORM_EDIT,
    UPDATE_FILE_DATA_SUCCESS,
    UPLOADING_FILE,
    UPLOADING_FILE_FAILURE,
    UPLOADING_FILE_SUCCESS,
    URL_FOR_UPLOAD_FETCHING,
    URL_FOR_UPLOAD_FETCHING_FAILURE,
    URL_FOR_UPLOAD_FETCHING_SUCCESS,
} from './types'

export const getUploadUrl = (filename, extension, mime) => dispatch => {
    dispatch({ type: URL_FOR_UPLOAD_FETCHING })

    Api.getUrlForUpload(filename, extension, mime)
        .then(response => {
            dispatch({
                type: URL_FOR_UPLOAD_FETCHING_SUCCESS,
                data: response.data,
            })
        })
        .catch(error => {
            dispatch({ type: URL_FOR_UPLOAD_FETCHING_FAILURE, error })
        })
}

export const uploadFile = file => dispatch => {
    dispatch({ type: URL_FOR_UPLOAD_FETCHING })

    const [name, ext] = file.name.split('.')

    Api.getUrlForUpload(name, ext, file.type)
        .then(response => {
            dispatch({
                type: URL_FOR_UPLOAD_FETCHING_SUCCESS,
                data: response.data,
            })

            const url = response.data.url
            const key = response.data.key

            dispatch({
                type: UPLOADING_FILE,
            })

            axios
                .put(url, file, {
                    headers: {
                        'Content-Type': file.type || 'application/octet-stream',
                    },
                })
                .then(_ => {
                    dispatch({
                        type: UPLOADING_FILE_SUCCESS,
                        url: 'https://product-assets.hurton.pl/' + key,
                    })
                })
                .catch(error => {
                    dispatch({ type: UPLOADING_FILE_FAILURE, error })
                })
        })
        .catch(error => {
            dispatch({ type: URL_FOR_UPLOAD_FETCHING_FAILURE, error })
        })
}

export const saveFileData = data => dispatch => {
    dispatch({ type: SAVING_FILE_DATA })

    Api.saveFileData(data)
        .then(_ => {
            dispatch({ type: SAVING_FILE_DATA_SUCCESS })
        })
        .catch(error => {
            dispatch({
                type: SAVING_FILE_DATA_FAILURE,
                error,
            })
        })
}

export const updateFileData = (id, data) => dispatch => {
    dispatch({ type: UPDATE_FILE_DATA })

    Api.updateFileData(id, data)
        .then(_ => {
            dispatch({ type: UPDATE_FILE_DATA_SUCCESS })
        })
        .catch(error => {
            dispatch({
                type: UPDATE_FILE_DATA_FAILURE,
                error,
            })
        })
}

export const getAssetTypes = () => dispatch => {
    dispatch({ type: ASSET_TYPES_FETCHING })

    Api.getAssetTypes()
        .then(response => {
            dispatch({
                type: ASSET_TYPES_FETCHING_SUCCESS,
                payload: response.data,
            })
        })
        .catch(error => {
            dispatch({
                type: ASSET_TYPES_FETCHING_FAILURE,
                error,
            })
        })
}

export const getProductAssetsForProduct = sku => dispatch => {
    dispatch({ type: PRODUCT_ASSETS_FETCHING })

    Api.getProductAssetsForProduct(sku)
        .then(response => {
            dispatch({
                type: PRODUCT_ASSETS_FETCHING_SUCCESS,
                payload: response.data.items,
            })
        })
        .catch(error => {
            dispatch({
                type: PRODUCT_ASSETS_FETCHING_FAILURE,
                error,
            })
        })
}

export const getProductAssets = (page, pageSize, query) => dispatch => {
    dispatch({ type: PRODUCT_ASSETS_FETCHING })

    Api.getProductAssets(page, pageSize, query)
        .then(response => {
            dispatch({
                type: PRODUCT_ASSETS_FETCHING_SUCCESS,
                payload: response.data.items,
                page: response.data.page,
                pageSize: response.data.pageSize,
                total: response.data.total,
                query: response.data.query,
            })
        })
        .catch(error => {
            dispatch({
                type: PRODUCT_ASSETS_FETCHING_FAILURE,
                error,
            })
        })
}

export const clearFileDataForm = () => dispatch => {
    dispatch({ type: CLEAR_FILE_DATA_FORM })
}

export const updateFileDataForm = data => dispatch => {
    dispatch({ type: UPDATE_FILE_DATA_FORM, payload: data })
}

export const fileDataFormAddSku = sku => dispatch => {
    dispatch({ type: FILE_DATA_FORM_ADD_SKU, payload: sku })
}

export const fileDataFormAddModel = model => dispatch => {
    dispatch({ type: FILE_DATA_FORM_ADD_MODEL, payload: model })
}

export const fileDataFormRemoveSku = sku => dispatch => {
    dispatch({ type: FILE_DATA_FORM_REMOVE_SKU, payload: sku })
}

export const fileDataFormRemoveModel = model => dispatch => {
    dispatch({ type: FILE_DATA_FORM_REMOVE_MODEL, payload: model })
}

export const updateFileDataFormEdit = (id, data) => dispatch => {
    dispatch({ type: UPDATE_FILE_DATA_FORM_EDIT, payload: data, id })
}

export const fileDataFormAddSkuEdit = (id, sku) => dispatch => {
    dispatch({ type: FILE_DATA_FORM_ADD_SKU_EDIT, payload: sku, id })
}

export const fileDataFormAddModelEdit = (id, model) => dispatch => {
    dispatch({ type: FILE_DATA_FORM_ADD_MODEL_EDIT, payload: model, id })
}

export const fileDataFormRemoveSkuEdit = (id, sku) => dispatch => {
    dispatch({ type: FILE_DATA_FORM_REMOVE_SKU_EDIT, payload: sku, id })
}

export const fileDataFormRemoveModelEdit = (id, model) => dispatch => {
    dispatch({ type: FILE_DATA_FORM_REMOVE_MODEL_EDIT, payload: model, id })
}

export const fileDataFormToggleActive = id => dispatch => {
    dispatch({ type: FILE_DATA_FORM_TOGGLE_ACTIVE, id })
}

export const fileDataFormDelete = (id, data) => dispatch => {
    dispatch({ type: FILE_DATA_FORM_DELETE, id })

    dispatch({ type: UPDATE_FILE_DATA })

    Api.updateFileData(id, data)
        .then(_ => {
            dispatch({ type: UPDATE_FILE_DATA_SUCCESS })
        })
        .catch(error => {
            dispatch({
                type: UPDATE_FILE_DATA_FAILURE,
                error,
            })
        })
}
